import React, { Component, createElement } from 'react'
import { createRoot } from 'react-dom/client';
import { createPortal} from 'react-dom'
import {I18nextProvider} from 'react-i18next';
import { withTranslation } from 'react-i18next'
import axios from 'axios'
import Cookie from '../../utils/Cookie'
import { loadModules } from 'esri-loader'

import HistoriskeBilder from '../HistoriskeBilder/HistoriskeBilder.jsx'
import Eierrapport from '../Eierrapport/Eierrapport.jsx'
import './MatrikkelMap.scss'
import { instanceOf } from 'prop-types';

class MatrikkelMap extends Component {

    state = {
        mapLoaded: false
    }

    isMeasurementActive = false
    isEierrapportActive = false

    componentDidMount = () => {
        this.initializeArcGIS();
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (nextProps.tokenInfo != null && this.currentToken != nextProps.tokenInfo.token) {
            if (this.esriId == null) return;
            var credentials = this.createIdentityManagerCredentials(nextProps.tokenInfo);
            this.esriId.destroyCredentials()
            this.esriId.initialize(credentials)
        }
    }

    showAdresse = (adresseId) => {
        // If missing adresse, clear map and exit
        if (adresseId == 0) {
            this.highlightLayer.removeAll()
            return
        }

        const url = `${this.props.settings.userConfiguration.mapservice.url}/${this.props.settings.userConfiguration.mapservice.layers["adresse"].layerId}`
        this.mapQuery(url, [], `id = ${adresseId}`, result => {
            if (result.features.length > 0)
            {
                var geometry = result.features[0].geometry
                this.highlightPoint(geometry, this.props.settings.userConfiguration.highlight.levels.adresse)
            }
        })
    }

    showAnleggsprojeksjonsflate = (anleggsprojeksjonsflateId) => {
        const url = `${this.props.settings.userConfiguration.mapservice.url}/${this.props.settings.userConfiguration.mapservice.layers["anleggsprojeksjonsflate"].layerId}`
        this.mapQuery(url, [], `id = ${anleggsprojeksjonsflateId}`, result => {
            if (result.features.length > 0)
            {
                var geometry = result.features[0].geometry
                this.highlightPolygon(geometry)
            }
        })
    }

    showBygg = (byggId) => {
        const url = `${this.props.settings.userConfiguration.mapservice.url}/${this.props.settings.userConfiguration.mapservice.layers["bygg"].layerId}`
        this.mapQuery(url, [], `id = ${byggId}`, result => {
            if (result.features.length > 0)
            {
                var geometry = result.features[0].geometry
                this.highlightPoint(geometry, this.props.settings.userConfiguration.highlight.levels.bygg)
            }
        })
    }

    showMatrikkelenhet = (matrikkelenhetId) => {
        // Get teiger for matrikkelenhet
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${matrikkelenhetId}/teig`, {
            params: {
                token: this.props.tokenInfo.token
            }
        })
        .then(({ data }) => {
            // Clear map and return if no teiger
            if (data.teiger.length == 0) {
                this.highlightLayer.removeAll()
                return
            }
            // Get the teig features
            const teigIds = data.teiger.map(teig => teig.teigId);
            const url = `${this.props.settings.userConfiguration.mapservice.url}/${this.props.settings.userConfiguration.mapservice.layers["teig"].layerId}`
            this.mapQuery(url, [], `id IN (${teigIds})`, result => {
                if (result.features.length > 0) {
                    var geometry = result.features[0].geometry.clone()
                    geometry.rings = [];
                    result.features.forEach((feature) => {
                        geometry.rings = geometry.rings.concat(feature.geometry.rings)
                    })
                    this.highlightPolygon(geometry)
                }
            })
        })
    }

    showTeig = (teigId) => {
        const url = `${this.props.settings.userConfiguration.mapservice.url}/${this.props.settings.userConfiguration.mapservice.layers["teig"].layerId}`
        this.mapQuery(url, [], `id = ${teigId}`, result => {
            if (result.features.length > 0)
            {
                var geometry = result.features[0].geometry
                this.highlightPolygon(geometry)
            }
        })
    }

    showStedsnavn = (stedsnavn) => {
        var point = this.createPoint(stedsnavn.x, stedsnavn.y)
        this.highlightPoint(point, this.props.settings.userConfiguration.highlight.levels.stedsnavn)
    }

    onPopupShowDetails = data => {
        this.props.onSelectionInMap(data)
    }

    findFeature = (result) => {
        for (var index in result.features) {
            if (result.features[index].attributes.seksjonsnr == 0) return result.features[index]
        }

        return result.features[0]
    }

    highlightPolygon = geometry => {
        var graphic = this.createPolygonGraphic(geometry)
        this.highlightLayer.removeAll()
        this.highlightLayer.add(graphic)
        this.view.extent = geometry.extent.expand(2)
    }

    createPolygonGraphic = (geometry) => {
        return {
            geometry: geometry,
            symbol: this.props.settings.userConfiguration.highlight.polygonSymbol
        }
    }

    createPointGraphic = (geometry) => {
        return {
            geometry: geometry,
            symbol: this.props.settings.userConfiguration.highlight.pointSymbol
        }
    }

    clearHighlight = () => {
        if (!this.highlightLayer) return;
        this.highlightLayer.removeAll()
    }

    setMapDevice = (device, isMapActive, hasResults) => {
        if (!this.view) return;

        let padding = { left: 565, top: 0 };
        if (device == "mobile" && isMapActive) {
            padding = { left: 0, top: 0 };
        } else if (device == "mobile" && !isMapActive) {
            padding = { left: 0, top: 65 };
        } else if (device == "tablet") {
            padding = { left: 465, top: 0 };
        }

        if ((device == "tablet" || device == "desktop") && !hasResults) padding.left = 0

        this.view.padding = padding;
    }

    featureComparer = (a, b) => {
        if (a.popupTemplate.title == null) return 1
        if (b.popupTemplate.title == null) return -1

        if (a.popupTemplate.title.toLowerCase().startsWith("teig")) return -1
        if (a.popupTemplate.title.toLowerCase() == "omsetning") return 1

        if (a.popupTemplate.title > b.popupTemplate.title) return 1
        if (a.popupTemplate.title < b.popupTemplate.title) return -1
        return 0
    }

    createIdentityManagerCredentials = (tokenInfo) => {
        this.currentToken = tokenInfo.token
        var tokenValidityInMinutes = 60 + (tokenInfo.expires - tokenInfo.created) / 60000;
        var credentials = {
            serverInfos: [{
                server: "https://services.geodataonline.no/arcgis",
                tokenServiceUrl: "https://services.geodataonline.no/arcgis/tokens/",
                adminTokenServiceUrl: "https://services.geodataonline.no/arcgis/admin/generateToken",
                shortLivedTokenValidity: tokenValidityInMinutes,
                currentVersion: 10.6,
                hasServer: true
            }],
            oAuthInfos: [],
            credentials: [{
                userId: tokenInfo.username,
                server: "https://services.geodataonline.no/arcgis",
                token: tokenInfo.token,
                expires: tokenInfo.expires,
                validity: tokenValidityInMinutes,
                isAdmin: false,
                ssl: false,
                creationTime: tokenInfo.created,
                scope: "server",
                resources: [
                    "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapAdmin/MapServer",
                    "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapMatrikkelInnsyn/MapServer",
                    "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapBilder2/ImageServer"
                ]
            }
        ]
        };
        return credentials;
    }

    initializeArcGIS() {
        const options = { url: 'https://js.arcgis.com/4.20/' };
        loadModules([
            'esri/Map',
            'esri/geometry/Extent',
            'esri/geometry/Point',
            'esri/geometry/SpatialReference',
            'esri/identity/IdentityManager',
            'esri/layers/GraphicsLayer',
            'esri/layers/ImageryLayer',
            'esri/layers/MapImageLayer',
            'esri/layers/WMSLayer',
            'esri/layers/TileLayer',
            'esri/layers/VectorTileLayer',
            'esri/tasks/QueryTask',
            'esri/rest/support/Query',
            'esri/views/MapView',
            'esri/widgets/Expand',
            'esri/widgets/ScaleBar',
            'esri/widgets/LayerList',
            'esri/widgets/Legend',
            'esri/widgets/BasemapGallery',
            'esri/widgets/DistanceMeasurement2D',
            'esri/widgets/AreaMeasurement2D',
            'esri/tasks/IdentifyTask',
            'esri/rest/support/IdentifyParameters',
            'esri/core/watchUtils',
            'esri/core/promiseUtils',
            'esri/widgets/Sketch/SketchViewModel',
            'esri/geometry/projection',
            'esri/geometry/support/jsonUtils'
        ], options)
            .then(([
                Map,
                Extent,
                Point,
                SpatialReference,
                esriId,
                GraphicsLayer,
                ImageryLayer,
                MapImageLayer,
                WMSLayer,
                TileLayer,
                VectorTileLayer,
                QueryTask,
                Query,
                MapView,
                Expand,
                ScaleBar,
                LayerList,
                Legend,
                BasemapGallery,
                DistanceMeasurement2D,
                AreaMeasurement2D,
                IdentifyTask,
                IdentifyParameters,
                watchUtils,
                promiseUtils,
                SketchViewModel,
                projection,
                jsonUtils
            ]) => {

                this.esriId = esriId
                var credentials = this.createIdentityManagerCredentials(this.props.tokenInfo);
                this.esriId.initialize(credentials)
                this.esriId.on("dialog-create", () => {
                    this.esriId.dialog.destroy();
                    Cookie.removeAuthenticationCookie()
                    window.location.reload();
                })

                const { t } = this.props
 
                this.createPoint = (x, y) => {
                    return new Point({
                        x: x,
                        y: y,
                        spatialReference: new SpatialReference({ wkid: 25833 })                        
                    })
                }

      
                this.highlightPoint = (geometry, level) => {                    
                    var graphic = this.createPointGraphic(geometry)
                    this.highlightLayer.removeAll()
                    this.highlightLayer.add(graphic)
                    this.view.goTo({
                        target: geometry,
                        zoom: level
                    })
                }
            
                this.mapQuery = (url, outFields, where, callback) => {
                    var queryTask = new QueryTask(url)
                    var query = new Query();
                    query.returnGeometry = true
                    query.outFields = outFields
                    query.where = where
                    queryTask.execute(query).then(result => {
                        callback(result)
                    })
                }

                this.mapQueryByGeometry = (url, outFields, geometry, callback) => {
                    var queryTask = new QueryTask(url)
                    var query = new Query();
                    query.returnGeometry = true
                    query.outFields = outFields
                    query.geometry = geometry
                    queryTask.execute(query).then(result => {
                        callback(result)
                    })
                }

                // Get the default basemap (visible)
                let defaultBasemap;
                this.props.settings.userConfiguration.basemaps.forEach((basemap) => {
                    if (basemap.visible) {
                        defaultBasemap = {
                            baseLayers: basemap.baseLayers.map((baseLayer) => {
                                return baseLayer.type && baseLayer.type == "vector" ? 
                                    new VectorTileLayer({url: baseLayer.url}) : new TileLayer({ url: baseLayer.url })
                            }),
                            title: basemap.title,
                            id: basemap.id
                        }
                    }
                });
                if (!defaultBasemap) {
                    console.error("No visible basemap is set in config");
                }

                let map = new Map({
                    basemap: defaultBasemap
                });

                var extentSetting = Cookie.getProperty("extent")
                var mapExtent = extentSetting ? Extent.fromJSON(extentSetting) : this.props.settings.userConfiguration.extent;

                this.view = new MapView({
                    container: this.refs.map,
                    extent: mapExtent,
                    map: map,
                    constraints: {
                        rotationEnabled: false
                    }
                });

                // Popup options
                this.view.popup.dockOptions = {
                    buttonEnabled: false,
                    breakpoint: {
                        width: 640
                    }
                };
                this.view.popup.collapseEnabled = false;
                this.view.popup.dockEnabled = false;

                // When map is loaded
                this.view.when(() => {
                    // Custom popup action
                    this.view.popup.actionsMenuEnabled = false;
                    this.view.popup.on("trigger-action", (event) => {
                        if (event.action.id === "details") {
                            let data = this.view.popup.viewModel.selectedFeature.attributes["action"];
                            this.onPopupShowDetails(data);
                            this.view.popup.close();
                        }
                    });

                    // Create the Identify-stuff
                    let serviceConfig = this.props.settings.userConfiguration.mapservice;
                    let identifyTask = new IdentifyTask(serviceConfig.url);
                    let identifyParams = new IdentifyParameters(serviceConfig.indentifyParams);

                    let identifies =  []
                        this.props.settings.userConfiguration.identify.mapservices.map(identifyConfig => {
                        identifies.push({
                            parameters: new IdentifyParameters(identifyConfig.parameters),
                            task: new IdentifyTask(identifyConfig.url)
                        })
                    })

                    this.view.on("click", event => {
                        if (this.isMeasurementActive || this.isEierrapportActive) return

                        this.view.popup.close();

                        if (event.x < this.view.padding.left) {
                            return
                        }

                        identifyParams.geometry = event.mapPoint;
                        identifyParams.mapExtent = this.view.extent;

                        let identifyPromises = []

                        if (this.view.zoom >= serviceConfig.identifyFromZoomLevel) {
                            identifyPromises.push(identifyTask.execute(identifyParams))
                        }
                        else {

                            identifyParams.layerIds = [7];
                            identifyParams.tolerance = 0;
                            identifyPromises.push(identifyTask.execute(identifyParams))
                        }                        

                        identifies.map(identifyConfig => {
                            let identifyParameters = identifyConfig.parameters
                            identifyParameters.geometry = event.mapPoint;
                            identifyParameters.mapExtent = this.view.extent;
                            identifyPromises.push(identifyConfig.task.execute(identifyParameters))
                        })
                        

                        promiseUtils.eachAlways(identifyPromises).then(identifyPromiseResults => {
                            let matrikkelResults = []
                            if (!identifyPromiseResults[0].error) {
                                matrikkelResults = identifyPromiseResults[0].value.results
                            }
                           
                            let otherResults = []

                            identifyPromiseResults.shift()

                            if (identifyPromiseResults.length == 0)
                            {
                                this.view.popup.title = null
                            }

                            identifyPromiseResults.map(identifyPromiseResult => {
                                if (!identifyPromiseResult.error) {
                                    otherResults.push(...identifyPromiseResult.value.results)
                                }
                            })

                            let features = [];
                            let relatedPromise = new Promise((resolve, reject) => {
                                resolve([])
                            });


                            matrikkelResults.map(result => {
                                let layerName = result.layerName;
                                let layerConfig = serviceConfig.layers[layerName.toLowerCase()];

                                // Modify the feature popup-template
                                let feature = result.feature;
                                let actionTitle = t('kart.popupPrefiks') + (layerConfig.actionSuffix || layerName.toLowerCase());
                                feature.popupTemplate = {
                                    title: layerName,
                                    overwriteActions: true,
                                    actions: [
                                        { title: actionTitle, id: "details", className: "esri-icon-documentation" }
                                    ]
                                };

                                // Get popup-content, optionally from relationship and/or api, or just raw from feature
                                if (typeof layerConfig.relationshipId !== "undefined") {
                                    // Needs a promise, since the number of graphics is unknown
                                    relatedPromise = new Promise((resolve, reject) => {
                                        this.getRelatedData(serviceConfig.url, result.layerId, feature.attributes["OID"], layerConfig.relationshipId).then(dataItems => {
                                            // For each related feature
                                            let relatedFeaturesPromises = dataItems.map((data) => {
                                                let relatedFeature = feature.clone();
                                                if (layerConfig.api) {
                                                    relatedFeature.attributes["action"] = { domain: layerConfig.domain, id: data[layerConfig.attribute] };
                                    
                                                    // Ensure this API call completes before resolving the promise
                                                    return this.getApiData(layerConfig.api, data[layerConfig.attribute]).then(({ data }) => {
                                                        relatedFeature.popupTemplate.content = this.formatPopupContent(layerConfig.template, data);
                                                        if (layerConfig.titleTemplate != null) {
                                                            relatedFeature.popupTemplate.title = layerName + " " + this.formatPopupContent(layerConfig.titleTemplate, data);
                                                        }
                                                        return relatedFeature;  // Return the related feature after populating the content
                                                    });
                                                }
                                                return Promise.resolve(relatedFeature);  // Return resolved promise if no API call
                                            });
                                    
                                            // Use Promise.all to ensure all related features are processed
                                            Promise.all(relatedFeaturesPromises).then(relatedFeatures => {
                                                resolve(relatedFeatures);
                                            }).catch(reject);  // Handle any errors from the API requests
                                        }).catch(reject);  // Handle any errors from the getRelatedData call
                                    });
                                } else if (layerConfig.api) {
                                    feature.attributes["action"] = { domain: layerConfig.domain, id: feature.attributes[layerConfig.attribute] };
                                    feature.popupTemplate.content = this.getApiDataContent(layerConfig.api, feature.attributes[layerConfig.attribute], layerConfig.template);
                                    features.push(feature);
                                } else {
                                    feature.popupTemplate.actions = [];
                                    feature.popupTemplate.content = this.formatPopupContent(layerConfig.template, feature.attributes);
                                    features.push(feature);
                                }
                            })

                            otherResults.map(result => {
                                let layerConfig = this.props.settings.userConfiguration.identify.layers[result.layerName.toLowerCase()]
                                let feature = result.feature;

                                let hasRequiredAttributes = true
                                if (layerConfig.requiredAttributes) {
                                    layerConfig.requiredAttributes.map(attributeName => {
                                        if (feature.attributes[attributeName] == null || feature.attributes[attributeName] == 'Null') hasRequiredAttributes = false
                                    })                                    
                                }

                                if (!hasRequiredAttributes) return

                                feature.popupTemplate = {
                                    title: layerConfig.title.toUpperCase(),
                                    overwriteActions: true,
                                    actions: [],
                                    content: this.formatPopupContent(layerConfig.template, feature.attributes)
                                };

                                features.push(feature);
                            })

                            relatedPromise.then(relatedFeatures => {       
                                if (relatedFeatures.length > 0) {
                                    features.push(...relatedFeatures)                                    
                                }

                                features.sort(this.featureComparer)

                                let popupHandler = this.view.popup.watch("visible", () => {
                                    popupHandler.remove()
                                    let header = document.getElementsByClassName("esri-popup__feature-menu-header")[0]
                                    let closeButton = document.createElement("DIV")
                                    closeButton.classList.add("closeButton")
                                    closeButton.classList.add("esri-popup__button")
                                    closeButton.setAttribute("role", "button")
                                    header.parentNode.insertBefore(closeButton, header.nextSibling)

                                    let root = createRoot(closeButton)
                                    root.render(<span aria-hidden="true" className="esri-popup__icon esri-icon-close" onClick={() => this.view.popup.close()}></span>)
                                })

                                if (this.isMeasurementActive || this.isEierrapportActive) return
                                this.view.popup.open({
                                    features: features,
                                    location: event.mapPoint,
                                    featureMenuOpen: true
                                });
                            })
                        })
                    });

                    this.setState({ mapLoaded: true });
                });

                this.view.watch("extent", extent => {
                    Cookie.setProperty("extent", extent.toJSON())
                })

                // Identify support methods
                this.getApiDataContent = (method, id, template) => {
                    return axios.get(`${this.props.settings.baseUrl}api/${method}/${id}`, {
                        params: {
                            token: this.props.tokenInfo.token
                        }
                    }).then(({ data }) => {
                        return this.formatPopupContent(template, data);
                    });
                }

                this.getApiData = (method, id) => {
                    return axios.get(`${this.props.settings.baseUrl}api/${method}/${id}`, {
                        params: {
                            token: this.props.tokenInfo.token
                        }
                    });
                }

                this.getRelatedData = (service, layer, oid, rid) => {
                    let url = `${service}/${layer}/queryRelatedRecords`;
                    return axios.get(url, {
                        params: {
                            token: this.props.tokenInfo.token,
                            objectIds: oid,
                            relationshipId: rid,
                            outFields: "*",
                            returnGeometry: false,
                            f: "json"
                        }
                    }).then(({ data }) => {
                        if (data.relatedRecordGroups && data.relatedRecordGroups.length > 0) {
                            if (data.relatedRecordGroups[0].relatedRecords.length > 0) {

                                return data.relatedRecordGroups[0].relatedRecords.map(record => {
                                    return record.attributes;
                                });

                                //return data.relatedRecordGroups[0].relatedRecords[0].attributes;
                            }
                        }
                        //return {};
                        return [{}];                                            
                    });
                }

                this.formatPopupContent = (template, data) => {
                    return template.replace(/{(\w+)}/g, function (_, k) {
                        let val = data[k];
                        val = (val == null) ? "" : val;
                        val = (val == "Null") ? "" : val;
                        return val;
                    });
                }

                //this.view.on("click", this.onMapClick)

                // Move the zoom
                this.view.ui.move("zoom", "top-right");

                // Scalebar
                if (this.props.settings.userConfiguration.tools.scalebar) {
                    this.view.ui.add(new ScaleBar({
                        view: this.view,
                        style: this.props.settings.userConfiguration.tools.scalebar.style,
                        unit: this.props.settings.userConfiguration.tools.scalebar.unit
                    }), "bottom-right");
                }

                // Basemap gallery                
                if (this.props.settings.userConfiguration.tools.basemaps) {
                    let basemaps = this.props.settings.userConfiguration.basemaps.map((basemap) => {
                        return {
                            baseLayers: basemap.baseLayers.map((baseLayer) => {
                                return baseLayer.type && baseLayer.type == "vector" ? 
                                    new VectorTileLayer({url: baseLayer.url}) : new TileLayer({ url: baseLayer.url })
                            }),
                            title: basemap.title,
                            id: basemap.id,
                            thumbnailUrl: basemap.thumbnail
                        }
                    });

                    this.view.ui.add(new Expand({
                        view: this.view,
                        autoCollapse: true,
                        group: "map-tools",
                        expandTooltip: t('kart.bakgrunnskart'),
                        content: new BasemapGallery({
                            view: this.view,
                            source: basemaps
                        })
                    }), "top-right");
                }

                // Layerlist
                if (this.props.settings.userConfiguration.tools.layerlist) {
                    let layerList = new LayerList({
                        view: this.view,
                        listItemCreatedFunction: (event) => {
                            if (!event.item.parent) {
                                if (this.props.settings.userConfiguration.tools.layerlist.opacity) {
                                    event.item.actionsSections = [[
                                        { title: "Mer gjennomsiktighet", className: "esri-icon-up", id: "increase-opacity" },
                                        { title: "Mindre gjennomsiktighet", className: "esri-icon-down", id: "decrease-opacity" }
                                    ]];
                                }
                            }
                        }
                    });
                    layerList.on("trigger-action", (event) => {
                        let layer = event.item.layer;
                        if (layer) {
                            if (event.action.id == "decrease-opacity") {
                                if (layer.opacity < 1) layer.opacity += 0.1;
                            } else if (event.action.id == "increase-opacity") {
                                if (layer.opacity > 0) layer.opacity -= 0.1;
                            }
                        }
                    });

                    this.view.ui.add(new Expand({
                        view: this.view,
                        group: "map-tools",
                        autoCollapse: true,
                        expandTooltip: t('kart.kartlag'),
                        content: layerList
                    }), "top-right");
                }

                // Legend               
                if (this.props.settings.userConfiguration.tools.legend) {
                    this.view.ui.add(new Expand({
                        view: this.view,
                        autoCollapse: true,
                        group: "map-tools",
                        expandTooltip: t('kart.tegnforklaring'),
                        content: new Legend({
                            view: this.view
                        })
                    }), "top-right");
                }

                // Other layers - TODO: Legge dette (og sikker noe over) i egen util-klasse?
                this.props.settings.userConfiguration.layers.forEach((layer) => {
                    if (layer.type == "dynamic") {
                        delete layer.type;
                        map.add(new MapImageLayer(layer));
                    } else if (layer.type == "wms") {
                        delete layer.type;
                        var wmsLayer = new WMSLayer(layer)
                        watchUtils.watch(wmsLayer, "visible", (visible) => {
                             wmsLayer.sublayers.forEach(sublayer => {
                                 sublayer.visible = visible;
                               });
                        });
                        map.add(wmsLayer);
                    }
                });

                // Add highlight layer last (at top)
                this.highlightLayer = new GraphicsLayer({
                    listMode: "hide"
                });
                map.add(this.highlightLayer);

                // These map-tools not on mobile devices
                if (!this.props.isMobile) {

                    // Measure distance
                    if (this.props.settings.userConfiguration.tools.distance) {
                        let measure = new DistanceMeasurement2D({
                            unit: this.props.settings.userConfiguration.tools.distance.unit,
                            unitOptions: this.props.settings.userConfiguration.tools.distance.unitOptions,
                            iconClass: "esri-icon-polyline"
                        });
                        let expand = new Expand({
                            view: this.view,
                            group: "map-tools",
                            expandTooltip: t('kart.avstand'),
                            content: measure
                        });
                        this.view.ui.add(expand, "top-right");
                        expand.watch("expanded", (newValue, oldValue, property, object) => {
                            if (newValue) {
                                this.view.popup.close()
                                this.isMeasurementActive = true

                                measure.view = this.view;
                                measure.viewModel.start();
                            } else {
                                this.isMeasurementActive = false
                                measure.viewModel.clear();
                                measure.view = null;
                            }
                        })
                    }

                    // Measure area
                    if (this.props.settings.userConfiguration.tools.area) {
                        let measure = new AreaMeasurement2D({
                            //unit: this.props.settings.userConfiguration.tools.area.unit,
                            unitOptions: this.props.settings.userConfiguration.tools.area.unitOptions,
                            iconClass: "esri-icon-polygon"
                        });
                        let expand = new Expand({
                            view: this.view,
                            group: "map-tools",
                            expandTooltip: t('kart.areal'),
                            content: measure
                        });
                        this.view.ui.add(expand, "top-right");
                        expand.watch("expanded", (newValue, oldValue, property, object) => {                            
                            if (newValue) {
                                this.view.popup.close()
                                this.isMeasurementActive = true

                                measure.view = this.view;
                                measure.viewModel.start();
                            } else {
                                this.isMeasurementActive = false
                                measure.viewModel.clear();
                                measure.view = null;                        
                            }
                        })
                    }
                    
                    if (this.props.settings.hasGeomapBilder) {
                        var historiskeBilderContainer = document.createElement("div")
                        let expand = new Expand({
                            view: this.view,
                            group: "map-tools",
                            expandIconClass: "esri-icon-collection",
                            expandTooltip: 'Historiske bilder',
                            content: historiskeBilderContainer
                        });
                        this.view.ui.add(expand, "top-right");

                        let root = createRoot(historiskeBilderContainer)
                        root.render(<I18nextProvider i18n={this.props.i18n}><HistoriskeBilder view={this.view} expand={expand} Query={Query} QueryTask={QueryTask} ImageryLayer={ImageryLayer} watchUtils={watchUtils} token={this.props.tokenInfo.token} /></I18nextProvider>)
                    }

                    if (this.props.settings.hasEier) {
                         let sketchViewModel = new SketchViewModel({
                            view: this.view,
                            layer: this.highlightLayer,
                            polygonSymbol: {
                                "type": "simple-fill",
                                "color": [ 0, 255, 255, 0.2 ],
                                "outline": {
                                  "color": [ 0, 255, 255 ],
                                  "width": 2
                                }
                            },
                            polylineSymbol: {
                                type: "simple-line",
                                color: [ 0, 255, 255 ],
                                width: 2
                              }

                        });

                        sketchViewModel.on("update", (event) => {
                            sketchViewModel.cancel();
                        });

                        var eierrapportContainer = document.createElement("div")
                        let expand = new Expand({
                            view: this.view,
                            group: "map-tools",
                            expandIconClass: "esri-icon-group",
                            expandTooltip: 'Eierrapport',
                            content: eierrapportContainer
                        });
                        expand.watch("expanded", (newValue, oldValue, property, object) => {
                            if (newValue) {
                                this.view.popup.close()
                                this.highlightLayer.removeAll();
                                this.isEierrapportActive = true
                            } else {
                                this.isEierrapportActive = false
                                sketchViewModel.cancel();
                            }
                        });
                        this.view.ui.add(expand, "top-right");

                        let root = createRoot(eierrapportContainer)

                        root.render(<I18nextProvider i18n={this.props.i18n}><Eierrapport view={this.view} expand={expand} graphicsLayer={this.highlightLayer} MapImageLayer={MapImageLayer} sketchViewModel={sketchViewModel} projection={projection} SpatialReference={SpatialReference} jsonUtils={jsonUtils} settings={this.props.settings} token={this.props.tokenInfo.token} /></I18nextProvider>)
                    }
                }

                // TODO: Må rydde i denne logikken (mobile/device/mapActive)
                const device = this.props.isMobile ? "mobile": "desktop";
                this.setMapDevice(device, false);

            })
            .catch(err => {
                console.error(err);
            });
    }

    render() {
        return (<div ref='map' className="matrikkelmap"></div>)
    }
}

export default withTranslation('common', { withRef: true})(MatrikkelMap)